import React, { useState, useEffect } from 'react';
import '../../../Assets/Css/EmpAttendanceSummery.scss';
import Absent from '../../../Assets/Images/Attendance/absent.svg';
import Calander from '../../../Assets/Images/Attendance/calander.svg';
import Holiday from '../../../Assets/Images/Attendance/Holiday.svg';
import Late from '../../../Assets/Images/Attendance/late.svg';
import RightArrow from '../../../Assets/Images/Attendance/Right Arrow.svg';
import Leave from '../../../Assets/Images/Attendance/leave.svg';
import Halfday from '../../../Assets/Images/Attendance/half-day.svg';
import { Link } from 'react-router-dom';
import moment from 'moment';
import UserAvatar from 'react-user-avatar';

const statusMap = {
    p: 'Present',
    a: 'Absent',
    la: 'Late',
    hod: 'Holiday',
    Sun: 'Holiday',
    hd: 'Half Day',
    ol: 'On Leave',
};

const EmpAttendanceSummery = (props) => {
    const currentDate = moment();
    const defaultMonth = currentDate.month() + 1;
    const defaultYear = currentDate.year();
    const [daysInMonth, setDaysInMonth] = useState([]);
    const [employeeData, setEmployeeData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
    const [selectedYear, setSelectedYear] = useState(defaultYear);
    const userProfilePic = localStorage.getItem('userProfilePic');

    const attendanceData = props?.selectedUser
        ? props?.data?.attendance?.filter((att) => att?.employee_id === props?.selectedUser?.id) || []
        : props?.data?.user?.role?.name?.includes('hr')
            ? props?.data?.attendance || []
            : props?.data?.attendance?.filter((att) => att?.employee_id === props?.data?.user?.id) || [];

    const leaveData = props?.selectedUser
        ? props?.data?.leave?.filter((leave) => leave?.employee_id === props?.selectedUser?.id) || []
        : props?.data?.user?.role?.name?.includes('hr')
            ? props?.data?.leave || []
            : props?.data?.leave?.filter((leave) => leave?.employee_id === props?.data?.user?.id) || [];

    const users = props?.selectedUser
        ? props?.data?.users?.filter((user) => user?.id === props?.selectedUser?.id) || []
        : props?.data?.user?.role?.name?.includes('hr')
            ? props?.data?.users || []
            : props?.data?.users?.filter((user) => user?.id === props?.data?.user?.id) || [];

    const calculateDaysInMonth = (month, year) => {
        const days = moment(`${year}-${month}`, 'YYYY-M').daysInMonth();
        return Array.from({ length: days }, (_, index) => {
            const date = new Date(year, month - 1, index + 1);
            return { day: index + 1, dayName: date.toLocaleDateString('en-US', { weekday: 'short' }) };
        });
    };

    useEffect(() => {
        if (!props?.data?.attendance || !props?.data?.leave || !props?.data?.users) return;

        const attendanceMap = {};
        attendanceData?.forEach((item) => {
            const dateKey = moment(item?.date?.split(' ')[0]).format('YYYY-MM-DD');
            if (!attendanceMap[dateKey]) {
                attendanceMap[dateKey] = [];
            }
            attendanceMap[dateKey].push(item);
        });

        const leaveMap = {};
        leaveData.forEach((leave) => {
            if (leave.status === 'Approved') {
                const startDate = moment(leave?.start_date).startOf('day');
                const endDate = moment(leave?.end_date).startOf('day');
                let currentDate = startDate.clone();
                while (currentDate.isSameOrBefore(endDate, 'day')) {
                    const dateKey = currentDate.format('YYYY-MM-DD');
                    leaveMap[dateKey] = leaveMap[dateKey] || { ...leave };
                    currentDate.add(1, 'day');
                }
            }
        });

        const attendance = {};
        users.forEach((user) => {
            attendance[user.id] = { [defaultYear]: {} };
            for (let m = 1; m <= 12; m++) {
                const daysInMonth = moment(`${defaultYear}-${m}`, 'YYYY-M').daysInMonth();
                attendance[user.id][defaultYear][m] = [];

                for (let day = 1; day <= daysInMonth; day++) {
                    const date = moment(`${defaultYear}-${m}-${day}`, 'YYYY-M-DD');
                    const dateKey = date.format('YYYY-MM-DD');
                    const punch = attendanceMap[dateKey]?.filter((att) => att.employee_id === user.id) || [];
                    const leave = leaveMap[dateKey];
                    let status = '-';
                    let hours = '0:00';

                    if (date.isAfter(currentDate, 'day')) {
                        if (leave?.firstHalf && leave?.secondHalf) {
                            status = 'ol';
                            hours = '0:00';
                        } else if (leave?.firstHalf || leave?.secondHalf) {
                            status = 'hd';
                            hours = '4:00';
                        } else if (date.format('ddd') === 'Sun') {
                            status = 'Sun';
                            hours = '0:00';
                        }
                    } else if (date.format('ddd') === 'Sun') {
                        status = 'Sun';
                        hours = '0:00';
                    } else if (leave) {
                        if (leave?.firstHalf && leave?.secondHalf) {
                            status = 'ol';
                            hours = '0:00';
                        } else if (leave?.firstHalf || leave?.secondHalf) {
                            status = 'hd';
                            hours = '4:00';
                        }
                    } else if (punch.length > 0) {
                        let totalMinutes = 0;
                        let earliestClockIn = null;
                        punch.forEach((entry) => {
                            if (entry.clock_in) {
                                const clockIn = moment(entry.clock_in, 'HH:mm');
                                const clockOut = entry.clock_out
                                    ? moment(entry.clock_out, 'HH:mm')
                                    : moment(entry.date, 'HH:mm:ss').endOf('day');
                                totalMinutes += moment.duration(clockOut.diff(clockIn)).asMinutes();
                                if (!earliestClockIn || clockIn.isBefore(earliestClockIn)) {
                                    earliestClockIn = clockIn;
                                }
                            }
                        });
                        const hrs = Math.floor(totalMinutes / 60);
                        const mins = Math.floor(totalMinutes % 60);
                        hours = `${hrs}:${mins.toString().padStart(2, '0')}`;
                        status = earliestClockIn?.isAfter(moment('11:00', 'HH:mm')) ? 'la' : 'p';
                    } else {
                        status = 'a';
                        hours = '0:00';
                    }

                    attendance[user.id][defaultYear][m].push({
                        day: date.format('ddd'),
                        status,
                        hours,
                    });
                }
            }
        });

        const newEmployeeData = users.map((user) => ({
            id: user.id,
            name: user.name,
            role: user.designation?.name || user.role?.name || '',
            avatar: user.profile_pic || userProfilePic || '',
            attendance: attendance[user.id],
        }));

        setEmployeeData(newEmployeeData);
    }, [props?.data?.attendance, props?.data?.leave, props?.data?.users, props?.selectedUser]);

    useEffect(() => {
        try {
            let tempMonth = props?.selectFilters?.Month?.value
                ? moment(props.selectFilters.Month.value, 'MMMM').month() + 1
                : defaultMonth;
            let tempYear = props?.selectFilters?.Year?.value
                ? parseInt(props.selectFilters.Year.value)
                : defaultYear;

            setSelectedMonth(tempMonth);
            setSelectedYear(tempYear);

            const daysArray = calculateDaysInMonth(tempMonth, tempYear);
            setDaysInMonth(daysArray);

            let selectedData = employeeData.map((employee) => ({
                ...employee,
                attendance: {
                    [tempYear]: {
                        [tempMonth]: employee.attendance?.[tempYear]?.[tempMonth] || [],
                    },
                },
            }));

            if (props?.selectFilters?.Late?.value) {
                selectedData = selectedData.map((employee) => ({
                    ...employee,
                    attendance: {
                        [tempYear]: {
                            [tempMonth]: employee.attendance[tempYear][tempMonth].map((item) => ({
                                ...item,
                                status: statusMap[item.status] === props.selectFilters.Late.value ? item.status : '-',
                            })),
                        },
                    },
                }));
            }

            setFilteredData(selectedData);
        } catch (error) {
            console.error('Error in filtered useEffect: ', error);
        }
    }, [
        props?.selectFilters?.Month?.value,
        props?.selectFilters?.Year?.value,
        props?.selectFilters?.Late?.value,
        employeeData,
    ]);

    return (
        <div className="attendance-table">
            <div className="suggestion">
                <h6 className="m-0 me-2">Note :</h6>
                <div className="suggestion_comp">
                    <img src={Holiday} className="svg" alt="Holiday" />
                    <img src={RightArrow} className="svgarrow" alt="Arrow" />
                    Holiday
                </div>
                <div className="suggestion_comp">
                    <img src={Calander} className="svg" alt="Present" />
                    <img src={RightArrow} className="svgarrow" alt="Arrow" />
                    Present
                </div>
                <div className="suggestion_comp">
                    <img src={Halfday} className="svg" alt="Half Day" />
                    <img src={RightArrow} className="svgarrow" alt="Arrow" />
                    Half Day
                </div>
                <div className="suggestion_comp">
                    <img src={Late} className="svg" alt="Late" />
                    <img src={RightArrow} className="svgarrow" alt="Arrow" />
                    Late
                </div>
                <div className="suggestion_comp">
                    <img src={Absent} className="svg" alt="Absent" />
                    <img src={RightArrow} className="svgarrow" alt="Arrow" />
                    Absent
                </div>
                <div className="suggestion_comp">
                    <img src={Leave} className="svg" alt="On Leave" />
                    <img src={RightArrow} className="svgarrow" alt="Arrow" />
                    On Leave
                </div>
            </div>

            <div className="table_cont">
                <table>
                    <thead>
                        <tr>
                            <th className="firsttablehead">Employee</th>
                            {daysInMonth.map((item, idx) => (
                                <th key={idx}>
                                    {item.dayName.slice(0, 1)}
                                    {item.day}
                                </th>
                            ))}
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(filteredData.length > 0 ? filteredData : employeeData).map((employee, idx) => {
                            const attendanceForMonth =
                                employee.attendance?.[selectedYear]?.[selectedMonth] || [];
                            return (
                                <tr key={employee.id || idx}>
                                    <td className="employee-info">
                                        {employee.avatar ? (
                                            <img src={employee.avatar} alt={employee.name} />
                                        ) : (
                                            <UserAvatar
                                                name={employee.name || ''}
                                                size={40}
                                                style={{ textTransform: 'uppercase', color: 'white' }}
                                                color="#5757fe"
                                            />
                                        )}
                                        <div className="employee-info-details">
                                            <span>{employee.name}</span>
                                            <span className="role">{employee.role}</span>
                                        </div>
                                    </td>
                                    {attendanceForMonth.map((item, dayIdx) => (
                                        <td key={dayIdx} className="attendance-status">
                                            <Link
                                                to={['la', 'p'].includes(item.status) ? '/attendance/empdetails' : '#'}
                                                state={{
                                                    dayDetails: {
                                                        date: `${selectedYear}-${String(selectedMonth).padStart(2, '0')}-${String(
                                                            dayIdx + 1
                                                        ).padStart(2, '0')}`,
                                                        records: attendanceData.filter(
                                                            (att) =>
                                                                moment(att.date?.split(' ')[0]).format('YYYY-MM-DD') ===
                                                                `${selectedYear}-${String(selectedMonth).padStart(2, '0')}-${String(
                                                                    dayIdx + 1
                                                                ).padStart(2, '0')}`
                                                        ),
                                                    },
                                                }}
                                            >
                                                {(() => {
                                                    switch (item.status) {
                                                        case 'Sun':
                                                            return (
                                                                <div className="sh-img">
                                                                    <img src={Holiday} className="svg_table" alt="Sunday" />
                                                                    <div className="tooltip">Sunday</div>
                                                                </div>
                                                            );
                                                        case 'hod':
                                                            return <img src={Holiday} className="svg_table" alt="Holiday" />;
                                                        case 'hd':
                                                            return <img src={Halfday} className="svg_table" alt="Half Day" />;
                                                        case 'la':
                                                            return <img src={Late} className="svg_table" alt="Late" />;
                                                        case 'p':
                                                            return <img src={Calander} className="svg_table" alt="Present" />;
                                                        case 'ol':
                                                            return <img src={Leave} className="svg_table" alt="On Leave" />;
                                                        case 'a':
                                                            return <img src={Absent} className="svg_table" alt="Absent" />;
                                                        default:
                                                            return <span style={{ fontWeight: 'normal' }}>-</span>;
                                                    }
                                                })()}
                                            </Link>
                                        </td>
                                    ))}
                                    <td className="total">
                                        {attendanceForMonth.reduce((count, item) => {
                                            if (['p', 'la'].includes(item.status)) return count + 1;
                                            if (item.status === 'hd') return count + 0.5;
                                            return count;
                                        }, 0)}
                                        /{daysInMonth.length}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default EmpAttendanceSummery;